import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import "containers/Spotlight/MySpotlight.css";
import "components/Spotlight/Spotlight_Common.css";
import "containers/ProjectCommon.css";
import "./PrivateUserProfile.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
import CoverBanner from "components/Spotlight/CoverBanner";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import FriendMotivationalBanner from "components/Tribe/Friends/UserDetail/FriendMotivationalBanner";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import FriendUserProfileBox from "components/Tribe/Friends/UserDetail/FriendUserProfileBox";
/*Friend Request methods*/
import * as FriendRequest from "components/Tribe/Friends/FriendRequestMethods";

/*Group helper method to delete a group invite*/
import * as GroupInvite from "components/Tribe/Groups/GroupHelperMethods";
import TextTheme from "components/General/Text/TextTheme";

class PrivateUserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: props.full_name,
      friendSlug: props.friendSlug,
      request_id: props.requestId,
      join_request_id:null,
      join_request_type:"",
      request_type: props.requestType,
      cover_pic: this.props.friendCoverPic || MyDefaultCoverPhoto,
      MyDefaultCoverPhoto,
      hasSentGroupRequest: "",
    };
  }

  componentDidMount() {
    // if this page will render the group invite motivational banner, check whether this user
    // has already sent a group request.
    if (this.state.request_type === CONSTANT.GROUP_INVITE_URL) {
      this.fetchAlreadySentGroupRequest(this);
    }
    this.fetchPendingRequest(this);
  }

  fetchPendingRequest(obj){
    AxiosConfig.get("friends/requests/pending/").then(function (response) {
      response?.data?.map((elem,index)=>{
        if(elem.requester.username === obj.state.friendSlug){
          obj.setState({
            join_request_id:elem.id,
            join_request_type:CONSTANT.RECEIVED
          })
        }
      })
    });
  }
  // check if this user has already sent a group request.
  fetchAlreadySentGroupRequest(obj) {
    AxiosConfig.get(
      `groups/invitations/${this.state.friendSlug}/${this.props.groupName}/`
    )
      .then(function (response) {
        obj.setState({ hasSentGroupRequest: true });
      })
      .catch(function (response) {
        obj.setState({ hasSentGroupRequest: false });
      });
  }

  /*render group member invite banner.*/
  renderGroupInviteBanner() {
    if (this.state.hasSentGroupRequest === true) {
      return (
        <div>
          <FriendMotivationalBanner
            type={CONSTANT.GROUP_INVITE_URL}
            friendSlug={this.state.friendSlug}
            full_name= {this.state.full_name}
            inviteOnClick={null}
            inviteDisabled={false}
            groupName={this.props.groupName}
          />
          <br />
          <br />
        </div>
      );
    } else if (this.state.hasSentGroupRequest === false) {
      return (
        <div>
          <FriendMotivationalBanner
            type={CONSTANT.GROUP_INVITE_URL}
            friendSlug={this.state.friendSlug}
            full_name={this.state.full_name}
            inviteOnClick={() =>
              GroupInvite.invite(this.state.friendSlug, this.props.groupID)
            }
            inviteDisabled={true}
            groupName={this.props.groupName}
          />
          <br />
          <br />
        </div>
      );
    }
  }

  render() {
    return (
      <div className="header_main main_possible_friend">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="main_pane">
            <div className="cover_photo">
              <div className="padding_above_cover"></div>
              <CoverBanner
                cover={this.state.cover_pic}
                profile={this.props.friendProfilePic}
              />
              <div className="padding_between"></div>
            </div>
            <div className="user_details">
              {this.state.request_type === CONSTANT.GUARDIAN_REVIEW ? (
                <FriendMotivationalBanner
                  type={CONSTANT.GUARDIAN_REVIEW}
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  declineOnClick={() =>
                    FriendRequest.decline(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                  acceptOnClick={() =>
                    FriendRequest.accept(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                  child_username={this.props.child_username}
                />
              ) : this.state.request_type === CONSTANT.INVITE_URL ? (
                <FriendMotivationalBanner
                  type={CONSTANT.INVITE_URL}
                  inviteDisabled={
                    this.props.friendStatus === "NONE" ||
                    this.props.friendStatus === "REJECTED"
                  }
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  inviteOnClick={() =>
                    FriendRequest.invite(this.state.friendSlug)
                  }
                />
              ) : this.state.request_type === CONSTANT.GROUP_INVITE_URL ? (
                this.renderGroupInviteBanner()
              ) : this.state.request_type === CONSTANT.RECEIVED ? (
                <FriendMotivationalBanner
                  type={CONSTANT.ARE_YOU_FRIENDS}
                  friendSlug={this.state.friendSlug}
                        full_name={this.state.full_name}
                  declineOnClick={() =>
                    FriendRequest.decline(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                  acceptOnClick={() =>
                    FriendRequest.accept(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                />
              ) : this.state.request_type ===
                  CONSTANT.GROUP_MEMBER_REVIEW_URL ||
                this.state.request_type === CONSTANT.GROUP_OWNER_REVIEW_URL ||
                this.state.request_type ===
                  CONSTANT.GROUP_MODERATOR_REVIEW_URL ? (
                <FriendMotivationalBanner
                  type={CONSTANT.GROUP_MEMBER_REVIEW_URL}
                  friendSlug={this.state.friendSlug}
                  cancelOnClick={() =>
                    GroupInvite.deleteInvite(this.props.groupRequestId, {
                      history: this.props.history,
                      type: CONSTANT.GROUP_MEMBER_REVIEW_URL,
                      group_name: this.props.groupName,
                      group_id: this.props.groupID,
                    })
                  }
                />
              ) : this.state.request_type === CONSTANT.RECEIVED_REQUEST ? (
                <FriendMotivationalBanner
                  type={CONSTANT.RECEIVED_REQUEST}
                  friendSlug={this.state.friendSlug}
                   full_name={this.state.full_name}
                  declineOnClick={() =>
                    GroupInvite.deleteInvite(this.props.groupRequestId, {
                      history: this.props.history,
                      type: CONSTANT.RECEIVED_REQUEST,
                      group_name: this.props.groupName,
                      group_id: this.props.groupID,
                    })
                  }
                  acceptOnClick={() =>
                    GroupInvite.acceptInvite(
                      this.state.friendSlug,
                      this.props.groupID,
                      {
                        history: this.props.history,
                        type: CONSTANT.RECEIVED_REQUEST,
                        group_name: this.props.groupName,
                        group_id: this.props.groupID,
                      }
                    )
                  }
                />
              ) : this.state.request_type === CONSTANT.REVIEW ? (
                <FriendMotivationalBanner
                  type={CONSTANT.CANCEL_REQUEST}
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  cancelOnClick={() =>
                    FriendRequest.decline(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                  acceptOnClick={() =>
                    FriendRequest.accept(
                      this.state.request_id,
                      this.state.request_type
                    )
                  }
                />
              ) : this.props.friendStatus === "NONE" ||
                this.props.friendStatus === "REJECTED" ? (
                <FriendMotivationalBanner
                  type={CONSTANT.INVITE_URL}
                  inviteDisabled={
                    this.props.friendStatus === "NONE" ||
                    this.props.friendStatus === "REJECTED"
                  }
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  inviteOnClick={() =>
                    FriendRequest.invite(this.state.friendSlug)
                  }
                />
              ) : null}
              {this.props.friendStatus === "PENDING" && this.state.request_type === CONSTANT.JOIN_URL ? (
                <FriendMotivationalBanner
                  type={CONSTANT.ARE_YOU_FRIENDS}
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  declineOnClick={() =>
                    FriendRequest.decline(
                      this.state.join_request_id,
                      this.state.join_request_type
                    )
                  }
                  acceptOnClick={() =>
                    FriendRequest.accept(
                      this.state.join_request_id,
                      this.state.join_request_type
                    )
                  }
                />
              ):""}
              <FriendUserProfileBox
                username={this.state.friendSlug}
                full_name={this.state.full_name}
                age={this.props.friendAge}
                // location={this.props.friendLocation}
                location=""
                profilePic={this.props.friendProfilePic}
              />
              <h4 className="aboutMeTitle">{CONSTANT.ABOUT_ME}</h4>
              <p>{this.props.about_me}</p>
              <h4 className="aboutMeTitle">{CONSTANT.MY_FAVORITE_THINGS}</h4>
              <p>{this.props.favorite_thing}</p>
              <h4 className="aboutMeTitle">{CONSTANT.MY_DREAM}</h4>
              <p>{this.props.dream}</p>
              <h4 className="aboutMeTitle">{CONSTANT.MY_HERO}</h4>
              <p>{this.props.heroes}</p>
              <h4 className="aboutMeTitle">{CONSTANT.MY_SUPERPOWERS}</h4>
              <p>{this.props.super_powers}</p>
              <h4 className="aboutMeTitle">{CONSTANT.I_SUPPORT}</h4>
              <ul>
                {this.props.project_interest &&
                this.props.project_interest.length > 0 ? (
                  this.props.project_interest.map((elem, index) => (
                    <li key={index}>{elem}</li>
                  ))
                ) : (
                  <div></div>
                )}
              </ul>
              <h4 className="aboutMeTitle">{CONSTANT.FAVORITE_CAUSES}</h4>
              <p>{this.props.cause}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivateUserProfile;
